// import React from 'react'
// // import "./UpcomingEvents.css"
// import Bmodel from "../UpcomingEvents/UpcomingEvents/Bmodel.jpeg";
// import iplauction from "../UpcomingEvents/UpcomingEvents/iplauction.jpg"
// const UpcomingEvents = () => {
//   return (
//     <section className="upcomingEvents">
//         <header className="p-5">
//             <h3 className="text-center" data-aos="fade-up">Upcoming Events</h3>
//         </header>
//         <div className="container-events d-flex justify-content-center align-items-center">
//             <div className="event-card center" data-aos="fade-up">
//                 <img className="eve-logo px-3" id="upimg" src={Bmodel} alt="Logo"/>
//                 <div className="event-slider centerY">
//                     <p><i>Business Model competition is a platform where various startups pitch in there ideas to tackle day to day problems infront of genuine investors who guide them during and even after the event.</i></p>
//                     <a id="businessModel" href="https://bmodel-ecellvssut.web.app/" target="_blank" style={{padding:" bottom 10px", color: "rgb(0,0,0)"}}><strong>VISIT WEBSITE</strong></a>
//                 </div>
//             </div>
//             </div>


//             <header className="p-5">
//                 <h3 className="text-center" data-aos="fade-up"></h3>
//             </header>
//             <div className="container-events d-flex justify-content-center align-items-center">
//                 <div className="event-card center" data-aos="fade-up">
//                     <img className="eve-logo px-3" id="upimg" src={iplauction} alt="" style={{height: "100%",width: "112%"}}/>
//                     <div className="event-slider centerY">
//                         <p><i>IPL auction gives all the active participants a chance to play the role of a bidder themselves and is an excellent platform to showcase one's bargaining skills and expertise.</i></p>
//                         <a id="businessModel" href="https://iplauction2k22.web.app/" target="_blank" 
//                         rel="noreferrer"style={{padding: "10px", color: "rgb(0,0,0)"}}><strong>VISIT WEBSITE</strong></a>
//                     </div>
//                 </div>
//                 </div>
//         </section>
    
//     )
// }

// export default UpcomingEvents
import React from 'react'

const UpcomingEvents = () => {
  return (
    <div>
      Upcoming Events
    </div>
  )
}

export default UpcomingEvents
